<zip-co-header></zip-co-header>

<main>
  <div class="content-max-width back-container">
    <span class="back-btn back-btn-rb" (click)="navigateHome()" [ngClass]="{ 'is-disabled': isLoading }"> All Gift Cards </span>
  </div>
  <div *ngIf="order; else loading" class="container">
    <div class="purchase-complete">
      <div class="left">
        <div class="img-contain">
          <img class="complete-card" [src]="order.product.imageUri" alt="" />
        </div>
        <ng-container *ngTemplateOutlet="mobileBottom"></ng-container>
      </div>
      <div class="right">
        <h1>
          <span> Hooray! </span>
        </h1>
        <ng-container *ngIf="order.gifting; then gifting else self"></ng-container>
        <div *ngIf="!isLoading" class="link-row hide-on-device">
          <span (click)="navigateHome()"> Continue browsing </span>
        </div>
      </div>
    </div>
  </div>
</main>

<ng-template #self>
  <div class="buy-another">
    <ng-container *ngIf="isLoading">
      <ng-container *ngTemplateOutlet="selfMainLoading"></ng-container>
    </ng-container>
    <ng-container *ngIf="!isLoading">
      <ng-container *ngTemplateOutlet="selfMain"></ng-container>
    </ng-container>
    <div class="hide-on-device">
      <ng-container *ngTemplateOutlet="selfNote"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #gifting>
  <div class="buy-another">
    <ng-container *ngIf="isLoading">
      <ng-container *ngTemplateOutlet="giftingMainLoading"></ng-container>
      <div class="hide-on-device">
        <div class="spinner-spacing-top">
          <app-spinner></app-spinner>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!isLoading">
      <ng-container *ngTemplateOutlet="giftingMain"></ng-container>
      <div class="giftcard-note hide-on-device">
        <ng-container *ngTemplateOutlet="giftingNote"></ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #mobileBottom>
  <div *ngIf="isLoading" class="show-on-device center">
    <div class="spinner-spacing-top">
      <app-spinner></app-spinner>
    </div>
  </div>
  <div *ngIf="!isLoading" class="show-on-device">
    <ng-container *ngIf="!order.gifting; then selfEmailSentTitle"></ng-container>
  </div>
  <div *ngIf="order.gifting && !isLoading" class="giftcard-note show-on-device">
    <ng-container *ngTemplateOutlet="giftingNote"></ng-container>
  </div>
  <div *ngIf="!order.gifting && !isLoading" class="giftcard-note show-on-device">
    <ng-container *ngTemplateOutlet="selfNote"></ng-container>
  </div>
  <div *ngIf="!isLoading" class="link-row show-on-device">
    <span (click)="navigateHome()"> Continue browsing </span>
  </div>
</ng-template>

<ng-template #selfMainLoading>
  <p>Your gift card is on its way.</p>
  <div class="hide-on-device">
    <div class="spinner-spacing-top">
      <app-spinner></app-spinner>
    </div>
  </div>
</ng-template>

<ng-template #selfMain>
  <div [hidden]="isOrderPending" class="btn-wrapper">
    <app-spinner *ngIf="isLoading"></app-spinner>
  </div>
  <p>
    Thank you for your purchase, your gift card is ready.
  </p>
  <div class="hide-on-device">
    <ng-container *ngTemplateOutlet="selfEmailSentTitle"></ng-container>
  </div>
</ng-template>

<ng-template #selfEmailSentTitle>
  <div class="email-sent-title" [hidden]="!isOrderPending">
    <p>
      We've sent it to your Zip email. It's usually pretty quick but can take up to 5
      minutes.
    </p>
  </div>
</ng-template>

<ng-template #selfNote>
  <div class="buy-another-title">
    Access your gift cards anytime from your Zip email.
    <br />
    Don't forget to check your spam folder if you can't find it.
  </div>
</ng-template>

<ng-template #giftingMainLoading>
  <div>
    <p>
      <span *ngIf="!deliveryDateUI">
        Your gift card is on its way to
        {{ order.gifting.recipientName }} ({{ order.gifting.recipientEmail }})
      </span>
      <span *ngIf="deliveryDateUI">
        We are scheduling your gift card to be sent to
        {{ order.gifting.recipientName }} ({{ order.gifting.recipientEmail }})
      </span>
    </p>
  </div>
</ng-template>

<ng-template #giftingMain>
  <p *ngIf="isOrderCompleted && !deliveryDateUI">
    We've sent the gift card to {{ order.gifting.recipientName }} ({{
      order.gifting.recipientEmail
    }})
  </p>
  <p *ngIf="deliveryDateUI">
    Your gift card will be sent on {{ deliveryDateUI }} to
      {{ order.gifting.recipientName }} ({{ order.gifting.recipientEmail }}).
  </p>
  <p *ngIf="isOrderPending && !deliveryDateUI">
    Your gift card is on its way to {{ order.gifting.recipientName }} ({{ order.gifting.recipientEmail}}).
  </p>
</ng-template>

<ng-template #giftingNote>
  <span *ngIf="isOrderCompleted && !deliveryDateUI">
    If the email goes missing, they might need to check their spam folder.
  </span>
  <span *ngIf="deliveryDateUI">
    They will receive it at 8:00am (your local time) on the delivery date. If the email
    goes missing, they might need to check their spam folder.
  </span>
  <span *ngIf="isOrderPending && !deliveryDateUI">
    It's usually pretty quick but can take up to 5 minutes. If the email goes missing, they
    might need to check their spam folder.
  </span>
</ng-template>

<ng-template #loading>
  <div class="spinner-contain">
    <app-spinner *ngIf="isLoading"></app-spinner>
  </div>
</ng-template>

<app-footer></app-footer>
